import React from "react";

export const Logo: React.FC<{ size?: number; className?: string }> = ({ size = 40, className }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={{ filter: "drop-shadow(0 0 5px rgba(0, 255, 65, 0.5))" }}
        >
            {/* Outer Hexagon / Frame */}
            <path
                d="M50 5L90 27.5V72.5L50 95L10 72.5V27.5L50 5Z"
                stroke="#00ff41"
                strokeWidth="2"
                strokeDasharray="200"
            />

            {/* Inner Server Bars / Pulse */}
            <rect x="30" y="35" width="40" height="4" fill="#00ff41" opacity="0.4">
                <animate attributeName="opacity" values="0.4;1;0.4" dur="2s" repeatCount="indefinite" />
            </rect>
            <rect x="30" y="45" width="40" height="4" fill="#00ff41">
                <animate attributeName="opacity" values="1;0.4;1" dur="2s" repeatCount="indefinite" />
            </rect>
            <rect x="30" y="55" width="40" height="4" fill="#00ff41" opacity="0.6">
                <animate attributeName="opacity" values="0.6;1;0.6" dur="2s" repeatCount="indefinite" />
            </rect>

            {/* Scanning line effect */}
            <line x1="15" y1="20" x2="85" y2="20" stroke="#00ff41" strokeWidth="1" opacity="0.3">
                <animate attributeName="y1" values="20;80;20" dur="4s" repeatCount="indefinite" />
                <animate attributeName="y2" values="20;80;20" dur="4s" repeatCount="indefinite" />
            </line>

            {/* Terminal prompt symbol */}
            <path d="M40 75L45 80L40 85" stroke="#00ff41" strokeWidth="2" />
            <line x1="48" y1="85" x2="58" y2="85" stroke="#00ff41" strokeWidth="2">
                <animate attributeName="opacity" values="0;1;0" dur="1s" repeatCount="indefinite" />
            </line>
        </svg>
    );
};
